import { render, staticRenderFns } from "./personDetail.vue?vue&type=template&id=56b51852&scoped=true&"
import script from "./personDetail.vue?vue&type=script&lang=js&"
export * from "./personDetail.vue?vue&type=script&lang=js&"
import style0 from "./personDetail.vue?vue&type=style&index=0&id=56b51852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b51852",
  null
  
)

export default component.exports